import smoothscroll from 'smoothscroll-polyfill';

import { on } from '../helpers/utils';

function headerLinks() {
  const links = document.querySelectorAll('.search-header__links a');

  links.forEach((link) => {
    const linkId = link.getAttribute('js-scroll');
    const scollElement = document.querySelector(`#${linkId}`);

    on('click', link, (event) => {
      event.preventDefault();
      let offsetPosition;

      if (window.matchMedia('(min-width: 1024px)').matches) {
        offsetPosition = scollElement.offsetTop - 140;
      } else {
        offsetPosition = scollElement.offsetTop - 80;
      }

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    });
  });
}

if (document.body.classList.contains('template-search')) {
  smoothscroll.polyfill();

  window.setTimeout(() => {
    headerLinks();
  }, 1000);
}
